// Getters
export const formValidation = (state) => {
  return state.formValidation.data || []
}
export const formValidationLoading = (state) => {
  return state.formValidation.loading
}
export const formValidationLastUpdate = (state) => {
  return state.formValidation.lastUpdate
}

export const indicadores = (state) => {
  const data = [...(state.indicadores.data || [])]
  const sortData = data.sort((a, b) => {
    return ('' + a.nome).localeCompare(b.nome)
  })

  return sortData
}
export const indicadoresLoading = (state) => {
  return state.indicadores.loading
}
export const indicadoresLastUpdate = (state) => {
  return state.indicadores.lastUpdate
}

export const questions = (state) => {
  return state.questions.data || []
}
export const questionsLoading = (state) => {
  return state.questions.loading
}
export const questionsLastUpdate = (state) => {
  return state.questions.lastUpdate
}

// Getters
export const performanceManagement = (state) => {
  return state.performanceManagement.data || []
}
export const performanceManagementLoading = (state) => {
  return state.performanceManagement.loading
}
export const performanceManagementLastUpdate = (state) => {
  return state.performanceManagement.lastUpdate
}

export const filterRH = (state) => {
  return state.filterRH
}
export const taskValuation = (state) => {
  return state.taskValuation.data || []
}
export const taskValuationLoading = (state) => {
  return state.taskValuation.loading
}
export const taskValuationLastUpdate = (state) => {
  return state.taskValuation.lastUpdate
}
export const professionalQuestionsGoals = (state) => {
  return state.professionalQuestionsGoals.data || []
}
export const professionalQuestionsGoalsLoading = (state) => {
  return state.professionalQuestionsGoals.loading
}
export const professionalQuestionsGoalsLastUpdate = (state) => {
  return state.professionalQuestionsGoals.lastUpdate
}
export const commercialEffort = (state) => {
  return state.commercialEffort.data || []
}
export const commercialEffortLoading = (state) => {
  return state.commercialEffort.loading
}
export const commercialEffortLastUpdate = (state) => {
  return state.commercialEffort.lastUpdate
}

